import cookies from "js-cookie";
import { useEffect, useState } from "react";

export const privacyFunctionalKey = "JOHNLEWIS_ENSIGHTEN_PRIVACY_Functional";

export function usePrivacyFunctionalAccepted() {
  const [hasAccepted, setAccepted] = useState(false);

  const handlePrivacyCookieChange = () => {
    if (cookies.get(privacyFunctionalKey) === "1") {
      setAccepted(true);
    }
  };

  useEffect(() => {
    if (cookies.get(privacyFunctionalKey) === "1") {
      setAccepted(true);
    } else {
      document.body.addEventListener(
        "jl-privacy:cookiePreferences",
        handlePrivacyCookieChange,
      );
    }
    return () => {
      document.body.removeEventListener(
        "jl-privacy:cookiePreferences",
        handlePrivacyCookieChange,
      );
    };
  }, []);
  return hasAccepted;
}
